import Card from "shared/ui/card";
import PaymentFooter from "widgets/payment/payment-footer";
import ContactCustomerService from "widgets/shared/contact-customer-service";
import { usePaymentContext } from "../providers/PaymentProvider";
import ZakelijkPaymentDetails from "./ZakelijkPaymentDetails";
import ZakelijkPaymentSidebarProducts from "./ZakelijkPaymentSidebarProducts";

export const ZakelijkPaymentPage = () => {
  const { doorOrderError } = usePaymentContext();

  // On Error, show contact customer service
  if (doorOrderError) {
    return (
      <Card className="gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-24">
        <ContactCustomerService />
      </Card>
    );
  }

  // Happy path, show payment details and sidebar
  return (
    <>
      <Card className="gg-px-4 gg-py-14 sm:gg-px-14 2xl:gg-px-24">
        <div className="gg-grid gg-grid-cols-12">
          <ZakelijkPaymentDetails />
          <div className="gg-col-span-12 xl:gg-col-span-6">
            <ZakelijkPaymentSidebarProducts />
          </div>
        </div>
      </Card>

      <PaymentFooter hideVoucher={true} />
    </>
  );
};
